import React from 'react'
import { ManagersCard } from './components/ManagersCard'
import { useManagersController } from './useManagersController'
import { Spinner } from '@/view/components/ui/spinner'
import { Button } from '../../components/ui/button'

export const Gerentes = () => {
  const { ref, data, isFetching, isLoading, hasNextPage, isFetchingNextPage } =
    useManagersController()

  return (
    <div>
      <div className="flex items-end justify-between">
        <h2 className="mb-8 text-2xl font-semibold">Gerentes</h2>
      </div>

      {isLoading ? (
        <div className="mt-8 flex items-center justify-center">
          <Spinner />
        </div>
      ) : (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(386px, 1fr))',
            gap: '16px',
          }}
        >
          {data &&
            data.pages.map((page, pageIndex) => {
              return (
                <React.Fragment key={pageIndex}>
                  {page.data.map((manager) => (
                    <ManagersCard key={manager._id} {...manager} />
                  ))}
                </React.Fragment>
              )
            })}
        </div>
      )}

      <div className="mt-2 flex items-center justify-center" ref={ref}>
        <Button variant="ghost" disabled={!hasNextPage || isFetchingNextPage}>
          {isFetchingNextPage ? <Spinner /> : null}
        </Button>
      </div>

      {isFetching && !isFetchingNextPage && !isLoading ? (
        <div className="mt-4 flex items-center justify-center">
          <Spinner />
        </div>
      ) : null}
    </div>
  )
}
